export class ActivityTracker {
  private static timeout = 1000 * 60 * 15;
  private static timer: number;
  private static handler: () => void;
  private static onHold = false;
  private static holdMs = 1000 * 10;

  public static isStarted = false;

  static startTimer(cb: () => void) {
    ActivityTracker.handler = cb;
    ActivityTracker.timer = window.setTimeout(() => {
      ActivityTracker.isStarted = false;
      cb();
    }, ActivityTracker.timeout);
  }
  static clearTimer() {
    window.clearTimeout(ActivityTracker.timer);
  }
  static resetTimer() {
    if (ActivityTracker.onHold) return;
    ActivityTracker.onHold = true;
    ActivityTracker.clearTimer();
    ActivityTracker.timer = window.setTimeout(ActivityTracker.handler, ActivityTracker.timeout);
    window.setTimeout(() => (ActivityTracker.onHold = false), ActivityTracker.holdMs);
    localStorage.setItem("tc", `reset${Date.now()}`);
  }
  static addListener(event: string) {
    window.addEventListener(event, ActivityTracker.resetTimer);
    ActivityTracker.isStarted = true;
  }
  static removeListener(event: string) {
    window.removeEventListener(event, ActivityTracker.resetTimer);
    ActivityTracker.isStarted = false;
  }
}
